import { render, staticRenderFns } from "./MenuPeople.vue?vue&type=template&id=1149c7f2"
import script from "./MenuPeople.vue?vue&type=script&lang=js"
export * from "./MenuPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports